import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import Footer from './Footer';

function TermsConditions() {
  return (
    <div className="App" style={{ paddingBottom: 'calc(120px + var(--spacing-lg))' }}>
      <header className="App-header" style={{ paddingBottom: '2em' }}>
        <h1 style={{ color: 'var(--color-green-primary)' }}>Terms & Conditions</h1>
        <p style={{ color: 'var(--color-text-secondary)', marginBottom: '1.5em' }}>
          <em>Last updated: June 2026</em>
        </p>

        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'left', lineHeight: '1.8' }}>
          <h2>1. Agreement to Terms</h2>
          <p>
            By purchasing, activating, installing, or using any Canopy Biosystems Inc product or service — including our dendrometer sensor hardware, embedded firmware, mobile and web software, and Canopy Sensor Data Dashboard (collectively, the "Products and Services") — you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not purchase or use our Products and Services.
          </p>

          <h2>2. Software and Dashboard License</h2>
          <p>
            Permission is granted to access and use the software and Dashboard components of our Products and Services for personal, non-commercial use only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modify or copy the software or Dashboard materials</li>
            <li>Use the software or materials for any commercial purpose or public display</li>
            <li>Attempt to decompile or reverse engineer any software contained in the Products and Services</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the software or materials to another person or mirror them on any other server</li>
          </ul>

          <h2>3. Hardware Use and Restrictions</h2>
          <p>
            Canopy Biosystems sensor hardware is sold, not licensed. However, the following restrictions apply to all hardware:
          </p>
          <ul>
            <li>Do not attempt to reverse engineer, disassemble, or replicate the hardware</li>
            <li>Do not modify the hardware in ways that void the warranty or violate applicable regulations (including FCC rules)</li>
            <li>Use the hardware only in accordance with the provided installation guidelines and within specified environmental tolerances</li>
            <li>Do not use the hardware for purposes other than plant monitoring as intended</li>
          </ul>

          <h2>4. Firmware</h2>
          <p>
            Canopy Biosystems may issue firmware updates to your device automatically (over-the-air) or manually. You agree to the following:
          </p>
          <ul>
            <li>You will not modify, replace, or tamper with the device firmware except as explicitly permitted by Canopy Biosystems</li>
            <li>Automatic firmware updates may be applied without prior notice to maintain device security and performance</li>
            <li>Canopy Biosystems is not responsible for any damage, data loss, or device malfunction caused by unauthorized firmware modifications</li>
          </ul>

          <h2>5. Installation and Physical Risk</h2>
          <p>
            Canopy Biosystems sensors are designed to be non-destructive when installed correctly. However:
          </p>
          <ul>
            <li>The user is solely responsible for correct installation in accordance with provided guidelines</li>
            <li>Canopy Biosystems is not liable for plant damage, crop loss, or property damage resulting from improper installation, misuse, or use outside of recommended conditions</li>
            <li>Do not install sensors on plants in a manner inconsistent with the instructions provided</li>
          </ul>

          <h2>6. Data Collection and Use</h2>
          <p>
            By using our Products and Services, you acknowledge and consent to the collection of data necessary to operate, improve, and support them — including sensor readings, general location, device identifiers, and usage information. This data is never sold to third parties. For full details on what we collect and how we use it, please review our <Link to="/privacy-policy" style={{ color: 'var(--color-green-primary)' }}>Privacy Policy</Link>.
          </p>

          <h2>7. Hardware Warranty</h2>
          <p>
            Canopy Biosystems Inc warrants its sensor hardware against manufacturing defects for one (1) year from the date of purchase. This warranty does not cover:
          </p>
          <ul>
            <li>Damage caused by improper installation, misuse, or accident</li>
            <li>Unauthorized hardware or firmware modifications</li>
            <li>Normal wear and tear or environmental damage outside specified tolerances</li>
            <li>Damage caused by use with third-party hardware or software not approved by Canopy Biosystems</li>
          </ul>
          <p>
            To initiate a warranty claim or return, please <Link to="/contact-us" style={{ color: 'var(--color-green-primary)' }}>contact us</Link>.
          </p>

          <h2>8. Disclaimer</h2>
          <p>
            The Products and Services are provided on an 'as is' basis. Canopy Biosystems Inc makes no warranties, expressed or implied, and hereby disclaims all other warranties including, without limitation, implied warranties of merchantability, fitness for a particular agricultural or horticultural purpose, accuracy of sensor readings, uninterrupted operation of hardware or software, or non-infringement of intellectual property or other violation of rights.
          </p>

          <h2>9. Limitations</h2>
          <p>
            In no event shall Canopy Biosystems Inc or its suppliers be liable for any damages (including, without limitation, damages for loss of data, crop loss, plant damage, loss of profit, or business interruption) arising out of the use or inability to use the Products and Services, even if Canopy Biosystems Inc or an authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>

          <h2>10. Accuracy of Materials</h2>
          <p>
            Information presented through our Products and Services, including sensor readings and analytics, could include technical or measurement errors. Canopy Biosystems Inc does not warrant that any data or materials are accurate, complete, or current. Canopy Biosystems Inc may make changes to the Products and Services at any time without notice.
          </p>

          <h2>11. Links</h2>
          <p>
            Canopy Biosystems Inc has not reviewed all sites linked to the Dashboard and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Canopy Biosystems Inc. Use of any linked website is at the user's own risk.
          </p>

          <h2>12. Modifications</h2>
          <p>
            Canopy Biosystems Inc may revise these terms at any time without notice. Continued use of the Products and Services constitutes acceptance of the then-current version of these terms.
          </p>

          <h2>13. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of the United States, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>

          <h2>14. Contact Us</h2>
          <p>
            If you have any questions about these Terms & Conditions, please contact us:
          </p>
          <ul>
            <li>By visiting this page on our website: <Link to="/contact-us" style={{ color: 'var(--color-green-primary)' }}>Contact Us</Link></li>
          </ul>
        </div>
      </header>

      <Footer />
    </div>
  );
}

export default TermsConditions;
